export const FETCH_APPROVED_DOMAINS = 'app/FETCH_APPROVED_DOMAINS';
export const SET_APPROVED_DOMAINS = 'app/SET_APPROVED_DOMAINS';
export const ADD_APPROVED_DOMAIN = 'app/ADD_APPROVED_DOMAIN';
export const REMOVE_APPROVED_DOMAIN = 'app/REMOVE_APPROVED_DOMAIN';
export const SET_APPROVED_DOMAINS_LOADING = 'app/SET_APPROVED_DOMAINS_LOADING';
export const SET_APPROVED_DOMAINS_ERROR = 'app/SET_APPROVED_DOMAINS_ERROR';
